import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardContent, TextField, Button } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    card: {
        minWidth: '80%',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
    },
    input: {
        marginBottom: 20,
    },
});

const EditRoute = ({ onAdded, item }) => {
    console.log(item);
    const classes = useStyles();
    const [id, setID] = useState(item._id);
    const [location, setLocation] = useState({
        name: item.name,
        address: item.address,
    });

    const handleChange = (event) => {
        setLocation({
            ...location,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        fetch(`http://biometick.com/modify-routes/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(location),
        })
            .then(function (response) {
                return response.text();
            }).then((result) => {
                console.log(result.body);
                result = JSON.parse(result);
                if (result.hasOwnProperty('_id')) {
                    onAdded('read');
                } else {
                    console.log('Some error occured while saving.');
                }
            })
            .catch((error) => console.error(error));
    };

    const handleDelete = () => {
        fetch(`/api/locations/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        })
            .then((response) => {
                if (response.ok) {
                    //     history.push('/locations');
                }
            })
            .catch((error) => console.error(error));
    };

    const handleCancel = () => {
        //history.push('/locations');
    };

    return (
        <div className={classes.root} style={{ minWidth: '100%', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card className={classes.card}>
                <CardContent>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <TextField
                            name="name"
                            label="Name"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            value={location.name}
                            onChange={handleChange}
                        />

                        <div style={{ width: '10px' }} />
                        <TextField
                            name="address"
                            label="Address"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            value={location.address}
                            onChange={handleChange}
                        />
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        fullWidth
                        style={{ height: '45px' }}
                    >
                        Edit
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default EditRoute;
